import { actions as notificationActions } from '@saucelabs/sl-container-notifications';

import * as selectors from './../test-overview/selectors';
import * as actions from './actions';
import { TESTS_BY_ERROR_LIMIT } from '../../constants';

export const getAggregatedTestErrors = (payload) => (dispatch, getState) => {
  const params = selectors.testOverviewFilterParamsSelector(getState(), payload);
  return dispatch(actions.getAggregatedTestErrors(params));
};

export const getTestsByError = (payload) => (dispatch, getState) => {
  const params = selectors.testOverviewFilterParamsSelector(getState(), payload);

  return dispatch(actions.getTestsByError({
    ...params,
    size: TESTS_BY_ERROR_LIMIT,
    error: payload.error,
  }, { errorName: payload.error }))
    .catch((error) => {
      dispatch(notificationActions.notifyDanger(
        error.message,
        'We\'ve experienced an issue while loading test errors.',
      ));
    });
};
